import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
// In production, use relative URLs (same origin) to avoid cross-domain issues
const isPreview = BACKEND_URL.includes("preview.emergentagent.com");
const BASE = isPreview ? BACKEND_URL : "";
export const API = `${BASE}/api`;
export const ASSET_BASE = BASE; // for /api/uploads/* and /api/storage/* assets

const api = axios.create({
    baseURL: API,
    timeout: 30000,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("trulyn_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            // token invalid; clear and reload
            localStorage.removeItem("trulyn_token");
            localStorage.removeItem("trulyn_user");
            if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/r/")) {
                window.location.href = "/login";
            }
        }
        return Promise.reject(err);
    }
);

export const assetUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http") || path.startsWith("data:") || path.startsWith("blob:")) return path;
    return `${ASSET_BASE}${path}`;
};

export default api;
